@if (loading.isLoading()) {
  <div class="loading-bar" role="progressbar" aria-label="Cargando" aria-busy="true">
    <div class="loading-bar__bar loading-bar__bar--primary">
      <span class="loading-bar__inner"></span>
    </div>
    <div class="loading-bar__bar loading-bar__bar--secondary">
      <span class="loading-bar__inner"></span>
    </div>
  </div>
}
